import { extend } from 'vee-validate';
import { required, email, numeric } from 'vee-validate/dist/rules';

// Add the required rule
extend('required', required);

// Add the select rule
extend('selectDeparture', {
    validate: value => {
        if (value == 0) {
            return false;
        } else {
            return true;
        }
    },
    message: 'Please select a shipping departure'
});

extend('selectArrival', {
    validate: value => {
        if (value == 0) {
            return false;
        } else {
            return true;
        }
    },
    message: 'Please select a shipping arrival'
});

// Add the quantity rule
extend('quantity', {
    validate: value => {
        if (value == 0) {
            return false;
        } else {
            return true;
        }
    },
    message: 'Please select a quantity'
});

// Add the numeric rule
extend('numeric', {
	validate: value => {
		const numericValue = new RegExp("^[0-9\.\/]+$");
		return numericValue.test(value);
	},
 	message: 'Please enter a valid number'
});

// Add the name rule
extend('fullName', {
  ...required,
  message: 'Please enter your full name'
});

// Add the email rule
extend('email', {
  ...email,
  ...required,
  message: 'Please enter a valid email'
});

// Add the phone rule
extend("phone", {
	message: "Please add a valid phone number.",
	validate: value => {
		const phoneRule = new RegExp("^[0-9 ]{10,}$");
		return phoneRule.test(value); //Test the regex. Test function returns a true or false value.
	}
});

// Add the required phone rule
extend('phoneRequired', {
    ...required,
    message: 'Please add a valid phone number.',
});

// Add the tracking rule
extend('tracking', {
  ...required,
  message: 'Please enter a valid BOL number'
});

// Add the Length rule
extend('length', {
  ...required,
  message: 'Please enter a length',
});

// Add the Width rule
extend('width', {
  ...required,
  message: 'Please enter a width',
});

// Add the Height rule
extend('height', {
  ...required,
  message: 'Please enter a height',
});

// Add the Weight rule
extend('weight', {
  ...required,
  message: 'Please enter a weight',
});

